import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredFerrisIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M18 18.7C19.3586 17.4849 20.3162 15.8859 20.7461 14.1146C21.176 12.3432 21.0579 10.4832 20.4076 8.78042C19.7572 7.07768 18.6051 5.61255 17.1038 4.57891C15.6025 3.54526 13.8227 2.99182 12 2.99182C10.1773 2.99182 8.39751 3.54526 6.89621 4.57891C5.39491 5.61255 4.24284 7.07768 3.59245 8.78042C2.94206 10.4832 2.82401 12.3432 3.25392 14.1146C3.68382 15.8859 4.64142 17.4849 6 18.7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
            fill="#FFFFFF"
          />
          <path
            d="M9 22L12 14L15 22"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
            fill="#FFFFFF"
          />
          <path
            d="M8 22H16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M12 2V6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M6.80005 15L3.30005 17"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M20.7 7L17.2 9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M6.80005 9L3.30005 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M20.7 17L17.2 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
            fill="#262626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
        </>
      ) : (
        <>
          <path
            d="M18 18.7C19.3586 17.4849 20.3162 15.8859 20.7461 14.1146C21.176 12.3432 21.0579 10.4832 20.4076 8.78042C19.7572 7.07768 18.6051 5.61255 17.1038 4.57891C15.6025 3.54526 13.8227 2.99182 12 2.99182C10.1773 2.99182 8.39751 3.54526 6.89621 4.57891C5.39491 5.61255 4.24284 7.07768 3.59245 8.78042C2.94206 10.4832 2.82401 12.3432 3.25392 14.1146C3.68382 15.8859 4.64142 17.4849 6 18.7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
            fill="#FFFFFF"
          />
          <path
            d="M12 14L9 22H15L12 14Z"
            fill="#D9D9D9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M8 22H16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M12 2V6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
          <path
            d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
            fill="#262626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M6.80005 15L3.30005 17"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
          <path
            d="M20.7 7L17.2 9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
          <path
            d="M6.80005 9L3.30005 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
          <path
            d="M20.7 17L17.2 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#18F0FF"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredFerrisIcon;
